export type TagModel = {
  cache_key: number,
  formatted_title?: string,
  global: boolean,
  hidden: boolean,
  template_pages_count?: number,
  id: number,
  image?: {
    file_name: string,
    preserved_560x560: string,
    preserved_1600x1200: string,
    original: string,
  },
  owner_id?: number,
  owner_type?: string,
  title: string,
}

export type TagRequestOptions = {
  include_tag_image?: boolean,
  include_tag_owner?: boolean,
  include_template_pages_count?: boolean,
  usable_tags_only?: boolean,
}

const state = {
  global: false,
  hidden: false,
  id: undefined,
  image_file: '',
  image_file_name: '',
  owner_id: undefined,
  owner_type: '',
  title: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'owner_id', validation: (ownerId: number, { global }: TagModel) => global || !!ownerId },
]

export default state
